import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <div class="app-container min-h-screen bg-base-black">
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [`
    .app-container {
      display: flex;
      flex-direction: column;
    }
  `]
})
export class AppComponent implements OnInit {
  title = 'avatar-generator-frontend';

  constructor(private translate: TranslateService) {
    // Configure available languages
    this.translate.addLangs(['es', 'en']);
    
    // Set default language
    this.translate.setDefaultLang('es');
    
    // Use Spanish as initial language
    this.translate.use('es');
  }

  ngOnInit(): void {
    // You can detect browser language here if needed
    // const browserLang = this.translate.getBrowserLang();
    // this.translate.use(browserLang?.match(/es|en/) ? browserLang : 'es');

    // TODO(sentry): conectar Sentry.setUser() al AuthService cuando aterrice el change login-register-ui
    // Cuando AuthService exista, suscribirse a currentUser$ aquí y llamar:
    //   Sentry.setUser({ id: user.id, email: user.email })  — en cada emisión con usuario
    //   Sentry.setUser(null)                                 — en logout (emisión null)
  }
}
